export default __webpack_public_path__ + "static/media/HND.1e5c766f.svg";